import Box from "@mui/material/Box";
import Navbar from "../Navbar";
import Footer from "../Footer";

const PublicLayout = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar />
    <Box sx={{ flex: 1 }}>{children}</Box>
    <Footer />
  </Box>
);

export default PublicLayout;
